import { render, staticRenderFns } from "./ViewDocumentType.vue?vue&type=template&id=0c836b9e"
import script from "./ViewDocumentType.vue?vue&type=script&lang=js"
export * from "./ViewDocumentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports